import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch, useSelector } from "react-redux";
import "./Start.scss";
import "../events/EventPage.css";
import { getAttending } from "../../redux/actions/attendingActions";
import AdminApproval from "./AdminApproval";
import AdminTrial from "./AdminTrial";
import Warning from "./Warning";
import ListBox from "../events/components/ListBox";

export default function StartLoggedIn() {
  const userFromState = useSelector(state => state.user);
  const { user, getAccessTokenSilently } = useAuth0();
  const attending = useSelector(state => state.attending);
  const dispatch = useDispatch();
  const [attendingEventList, setAttendingEventList] = useState([]);
  const [networkList, setNetworkList] = useState([]);
  const [viewInfo, setViewInfo] = useState(false);
  const [greeting, setGreeting] = useState("Hej");

  const handleViewInfoClick = () => {
    setViewInfo(!viewInfo);
  };

  useEffect(() => {
    if (user) {
      console.log(user);
      console.log(userFromState);
    }
    setGreeting(
      new Date().getHours() < 12
        ? "Godmorgon"
        : new Date().getHours() < 18
        ? "Hej"
        : new Date().getHours() < 22
        ? "Godkväll"
        : "Godnatt"
    );
  }, []);

  useEffect(() => {
    if (!attending || !attending.attendingEvents) {
      console.log("loading attending events");
      loadAttendingEvents();
    } else {
      buildAttendingEventList(attending);
    }
  }, [attending]);

  async function loadAttendingEvents() {
    const accessToken = await getAccessTokenSilently();
    const events = await dispatch(getAttending(accessToken));
    console.log(events);
    buildAttendingEventList(events);
  }

  function buildAttendingEventList(events) {
    if (!events) return;
    const today = new Date();
    const oneWeekFromNow = new Date();
    oneWeekFromNow.setDate(today.getDate() + 7);

    const list = events.attendingEvents
      .map(event => {
        const eventDate = new Date(event.startdate);
        if (eventDate >= today && eventDate <= oneWeekFromNow) {
          return event.deleted ? (
            <span key={event.id} className="event-deleted">
              INSTÄLLD {event.name}
            </span>
          ) : (
            <Link
              key={event.id}
              className="attending-link"
              to={`/event/${event.id}`}
            >
              {event.name}
            </Link>
          );
        }
        return null;
      })
      .filter(item => item !== null);
    setAttendingEventList(list);

    const networkList = events.networkAttendingEvents
      .map(networkEvent => {
        const eventDate = new Date(networkEvent.startdate);
        if (eventDate >= today && eventDate <= oneWeekFromNow) {
          return networkEvent.deleted ? (
            <span key={networkEvent.id} className="event-deleted">
              INSTÄLLD {networkEvent.name}
            </span>
          ) : (
            <Link
              key={networkEvent.id}
              className="attending-link"
              to={`/event/${networkEvent.id}`}
            >
              {networkEvent.name}
            </Link>
          );
        }
        return null;
      })
      .filter(item => item !== null);
    setNetworkList(networkList);
  }

  return (
    <div className="start">
      <div className="welcome">
        <h2>
          {greeting} {userFromState.name}!
        </h2>
      </div>
      {userFromState.warnings > 0 && <Warning />}
      <span className="label">Det här händer den närmaste veckan:</span>
      <div className="status">
        <ListBox
          className="attending-network-list"
          label="I ditt nätverk: "
          items={networkList}
        />
        <ListBox
          className="attending-list"
          label="För dig: "
          items={attendingEventList}
        />
      </div>
      {userFromState.role === "admin" && (
        <div className="admin-section">
          <AdminApproval />
          <AdminTrial />
        </div>
      )}
      {viewInfo && (
        <div className="about">
          <p>
            {" "}
            Det här är en samlingsplats för kristna sammankomster runt om i
            Sverige för alla oss som bekänner Jesus Kristus som Herre.
          </p>
          <p>
            I kalendern får du enkelt en överblick över vad som händer där du
            bor (eller i andra delar i Sverige). Om du loggar in kan du även
            lägga till händelser som du känner till, hålla koll på andra
            användare och mycket mer!
          </p>
          <p>
            Kalendern fylls av oss användare och tillsammans skapar vi fler
            möjligheter att mötas utanför våra sociala bubblor, hitta nya
            likasinnade och samla våra krafter till de initiativ vi vill ta som
            Guds folk.
          </p>
          <p>
            ... och du som ännu inte är kristen är självklart lika välkommen
            hit!
          </p>
          <p className="contact-info">kontakt: hoppetsfolk@gmail.com</p>
        </div>
      )}
      <button onClick={handleViewInfoClick}>
        {!viewInfo ? "om hemsidan" : "dölj"}
      </button>
    </div>
  );
}
